export default __webpack_public_path__ + "static/IstanbulWildcats-b4d850e4340466c6f65bcf5c13bd75b9.png";